import { StatsBlock } from '@graphql/__generated__/graphql';
import { StatsBlockProps } from '@stadionhq-v3/base-ui';
import { CleanContentful } from '@stadionhq-v3/clean-contentful';
import { ContentfulImage } from '@stadionhq-v3/contentful-ui';
import { THEMES, Theme } from '@stadionhq-v3/core';
import { Translations } from '@lib/dictionary-keys/__generated__';
import ImageWithAttribution from '@components/v3/molecules/image-with-attribution';
import { assetTransform } from '../atoms/asset.transform';

const statsBlockTransform = (
  { image, sponsor, stats, theme, ...statsBlock }: CleanContentful<StatsBlock>,
  dictionary: {
    sponsoredBy: Translations['common']['label']['sponsoredBy'];
  }
): StatsBlockProps => ({
  ...statsBlock,
  stats: stats.filter((stat: { label: string; value: string }) => stat.label),
  sponsor: sponsor
    ? {
        title: dictionary.sponsoredBy,
        image: <ContentfulImage {...assetTransform(sponsor)} />,
      }
    : undefined,
  theme: (theme as Theme) ?? THEMES.DEFAULT_1,
  image: image && (
    <ImageWithAttribution
      image={<ContentfulImage {...image} />}
      attribution={image.attribution}
    />
  ),
});

export default statsBlockTransform;
